import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import NullComponent from '../../../../../../../../../baseComponents/NullComponent'
import { CustomSelectWithSearchBar } from '../../../../../../../../../forms/CustomSelect'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { useMemo } from 'react'
import { DictPaymentBanksTy } from '../../../../../../../../../utils/hooks/payments/getDictPaymentBanks'
interface DictPaymentTypesProps {
    dictPaymentBanks: DictPaymentBanksTy | null
}
const useDictPaymentTypes = ({ dictPaymentBanks }: DictPaymentTypesProps) => {
    const dictPaymentTypes: Record<PaymentRelatedTypesKeys, { component: React.FC<any>, extraProps?: TwinDictionary }> | null = useMemo(() =>{ 
        if(!dictPaymentBanks){
            return null
        }
        return {
            0: {
                component: NullComponent
            },
            1: {
                component: CustomSelectWithSearchBar,
                extraProps: { items: dictPaymentBanks?.customerBanks?.items || {}, className: 'w-full custom_select_hide_label height_28 overflow-visible', fieldName: 'fullname', value: dictPaymentBanks?.customerBanks?.defaultId }
            },
            2: {
                component: CustomSelectWithSearchBar,
                extraProps: { items: dictPaymentBanks?.workingCenterBanks?.items || {}, className: 'w-full custom_select_hide_label height_28  overflow-visible', fieldName: 'fullname', value: dictPaymentBanks?.workingCenterBanks.defaultId }
            },
            3: {
                component: NullComponent
            },
            4: {
                component: NullComponent
            },
            5: {
                component: NullComponent
            },
            6: {
                component: CustomSelectWithSearchBar,
                extraProps: { items: dictPaymentBanks?.workingCenterShift4Devices?.items || {}, className: 'w-full custom_select_hide_label height_28  overflow-visible', fieldName: 'fullname', value: dictPaymentBanks?.workingCenterShift4Devices.defaultId }
            },
            7: {
                component: NullComponent
            }
        }
    }, [dictPaymentBanks])

    return { dictPaymentTypes }
}

export default useDictPaymentTypes